const constants = require('@/util/constants')
require('./config')

/**
 * 获取敏感词
 * 
 * @param {*} successcb 成功回调
 * @param {*} failedcb 失败回调
 */
// export function getTaboosAll (successcb, failedcb) {
//   axios.get('/api/taboo/all', {
//     params: {
//       'client': constants.HTTP_CLIENT
//     }
//   }).then(response => {
//     successcb(response.data)
//   }).catch(error => {
//     failedcb(error)
//   })
// }

/**
 * 获取敏感词
 * 
 * @param {*} successcb 成功回调
 * @param {*} failedcb 失败回调
 */
export function getTaboos(page, size, successcb, failedcb) {
  axios.get('/api/taboo/query', {
    params: {
      'page': page,
      'size': size,
      'client': constants.HTTP_CLIENT
    }
  }).then(response => {
    successcb(response.data)
  }).catch(error => {
    failedcb(error)
  })
}

// /**
//  * 创建敏感词
//  * @param {*} successcb 成功回调
//  * @param {*} failedcb 失败回调
//  */
// export function createTaboo (standard, synonyms, successcb, failedcb) {
//   axios.post('/api/taboo/create', {
//     standard,
//     synonyms
//   }).then(response => {
//     successcb(response.data)
//   }).catch(error => {
//     failedcb(error)
//   })
// }

// /**
//  * 更新敏感词
//  * @param {*} successcb 成功回调
//  * @param {*} failedcb 失败回调
//  */
// export function updateTaboo (tid, standard, synonyms, successcb, failedcb) {
//   axios.post('/api/taboo/update', {
//     tid,
//     standard,
//     synonyms
//   }).then(response => {
//     successcb(response.data)
//   }).catch(error => {
//     failedcb(error)
//   })
// }

// /**
//  * 删除敏感词
//  * @param {*} successcb 成功回调
//  * @param {*} failedcb 失败回调
//  */
// export function deleteTaboo (tid, successcb, failedcb) {
//   axios.post('/api/taboo/delete', {
//     tid
//   }).then(response => {
//     successcb(response.data)
//   }).catch(error => {
//     failedcb(error)
//   })
// }
